export default __webpack_public_path__ + "static/image5-b3a74b9a9e7a5a2fe72171bf7f281968.gif";